import { render, staticRenderFns } from "./ExemptionGrid.vue?vue&type=template&id=0b861ac2"
import script from "./ExemptionGrid.vue?vue&type=script&lang=js"
export * from "./ExemptionGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports